var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F1F3FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1835_48806)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1835_48806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 16.9969C24.1998 20.9734 20.9764 24.1969 16.9998 24.1969C13.0232 24.1969 9.7998 20.9734 9.7998 16.9969C9.7998 13.0203 13.0232 9.79688 16.9998 9.79688C20.9764 9.79688 24.1998 13.0203 24.1998 16.9969Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13.5781C17.1432 13.5781 17.2805 13.635 17.3818 13.7363C17.4831 13.8376 17.54 13.9749 17.54 14.1181V16.7749L19.1816 18.4165C19.2346 18.466 19.2772 18.5256 19.3067 18.5918C19.3362 18.6581 19.3521 18.7296 19.3533 18.8021C19.3546 18.8746 19.3413 18.9466 19.3141 19.0138C19.287 19.0811 19.2465 19.1422 19.1953 19.1934C19.144 19.2447 19.0829 19.2851 19.0157 19.3123C18.9484 19.3395 18.8764 19.3528 18.8039 19.3515C18.7314 19.3502 18.6599 19.3344 18.5937 19.3048C18.5274 19.2753 18.4678 19.2328 18.4184 19.1797L16.6184 17.3797C16.5171 17.2786 16.4601 17.1413 16.46 16.9981V14.1181C16.46 13.9749 16.5169 13.8376 16.6181 13.7363C16.7194 13.635 16.8567 13.5781 17 13.5781Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1835_48806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36035 8.35938H25.6403V25.6394H8.36035V8.35938Z",
    fill: "#214BA5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1835_48806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9e864704ba395e1fdc61838f4d0beff8.svg";
export { ForwardRef as ReactComponent };